export { default } from './Router';



// WEBPACK FOOTER //
// ./src/routing/Router/index.ts